// Generated types for Thread
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { StepWriteAPI } from './step';
import { ScopedNodeWriteAPISchema, ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';
import { StepWriteAPISchema } from './step';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ThreadReadAPI extends Omit<ScopedNodeReadAPI, 'created_at'> {
  /** When thread was created */
  created_at?: string | null;
  /** Thread name */
  name: string;
  /** Thread description */
  description?: string | null;
}

export interface ThreadWriteAPI extends ScopedNodeWriteAPI {
  /** Thread name */
  name: string;
  /** Thread description */
  description?: string | null;
  context_items?: (string | ScopedNodeWriteAPI)[];
  steps?: (string | StepWriteAPI)[];
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ThreadReadAPISchemaObject = ScopedNodeReadAPISchemaObject.omit({ 'created_at': true }).extend({
  created_at: z.string().nullable().optional(),
  name: z.string(),
  description: z.string().nullable().optional(),
}).passthrough();
export const ThreadReadAPISchema: z.ZodType<ThreadReadAPI> = ThreadReadAPISchemaObject;

export const ThreadWriteAPISchemaObject = ScopedNodeWriteAPISchemaObject.extend({
  name: z.string(),
  description: z.string().nullable().optional(),
  context_items: z.array(z.union([z.string(), z.lazy(() => ScopedNodeWriteAPISchema)])).optional(),
  steps: z.array(z.union([z.string(), z.lazy(() => StepWriteAPISchema)])).optional(),
}).passthrough();
export const ThreadWriteAPISchema: z.ZodType<ThreadWriteAPI> = ThreadWriteAPISchemaObject;
